export const defaultMaxResults = 50;

export enum filterId {
  query = 'query',
  excludeInactiveOwners = 'excludeInactiveOwners',
  excludeUsedInDashboard = 'excludeUsedInDashboard',
  excludeUsedInCompanyReport = 'excludeUsedInCompanyReport',
  excludeSharedInReport = 'excludeSharedInReport',
  excludeInvalidOwners = 'excludeInvalidOwners'
}

export enum FavouriteListIds {
  owner = 'owner',
  sharedWithUserGroups = 'sharedWithUserGroups',
  sharedWithUsers = 'sharedWithUsers'
}

export enum queryFilters {
  folderPath = 'search_in_folder_path'
}
